module.exports = __webpack_public_path__ + "static/img/ad4_03.acbc6be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ad4_03.jpg
// module id = Gr3J
// module chunks = 30